(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boost-cookie-script"] && !Shopify.designMode) return;
  try {
    function clearBoostStorage() {
    Object.keys(localStorage).forEach(function(key) {
      if (key.toLowerCase().indexOf('boost') !== -1) {
        // console.log('[BOOST] Removing localStorage:', key);
        localStorage.removeItem(key);
      }
    });

    Object.keys(sessionStorage).forEach(function(key) {
      if (key.toLowerCase().indexOf('boost') !== -1) {
        console.log('[BOOST] Removing sessionStorage:', key);
        sessionStorage.removeItem(key);
      }
    });
  }

  function waitForCustomerPrivacy(callback) {
    if (window.Shopify && Shopify.customerPrivacy) {
      callback();
    } else {
      setTimeout(function() {
        waitForCustomerPrivacy(callback);
      }, 100);
    }
  }

  function runBoostIfAllowed() {
    waitForCustomerPrivacy(function() {
      var cp = Shopify.customerPrivacy;
      var hasMarketingConsent = cp.marketingAllowed();

      // console.log('[BOOST] Marketing consent:', hasMarketingConsent);

      if (!hasMarketingConsent) {
        console.log('[BOOST] Blocking Boost');
        clearBoostStorage();

        // 🔥 HARD BLOCK Boost initialisation
        window.loadBoost = function () {
          // console.log('[BOOST] loadBoost blocked');
          return;
        };

        window.hasConsent = false;
        return;
      }

      console.log('[BOOST] Allowing Boost');

      window.hasConsent = true;

      if (typeof loadBoost === 'function') {
        loadBoost();
      }
    });
  }

  // Initial run
  runBoostIfAllowed();

  // Re-run on consent change
  document.addEventListener('visitorConsentCollected', runBoostIfAllowed);
  document.addEventListener('consent.accepted', runBoostIfAllowed);
  } catch(e) { console.error(e); }
})();

})();
